module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group  pt10px"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('span', {
    staticClass: "pr10px"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.timeMode),
      expression: "timeMode"
    }],
    attrs: {
      "type": "radio",
      "name": "t",
      "value": "0"
    },
    domProps: {
      "checked": _vm._q(_vm.timeMode, "0")
    },
    on: {
      "change": function($event) {
        _vm.timeMode = "0"
      }
    }
  }), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('span', {
    staticClass: "pr10px"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.timeMode),
      expression: "timeMode"
    }],
    attrs: {
      "type": "radio",
      "name": "t",
      "value": "1"
    },
    domProps: {
      "checked": _vm._q(_vm.timeMode, "1")
    },
    on: {
      "change": function($event) {
        _vm.timeMode = "1"
      }
    }
  }), _vm._v(" "), _vm._m(2)]), _vm._v(" "), _c('span', {
    staticClass: "pr10px"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.timeMode),
      expression: "timeMode"
    }],
    attrs: {
      "type": "radio",
      "name": "t",
      "value": "2"
    },
    domProps: {
      "checked": _vm._q(_vm.timeMode, "2")
    },
    on: {
      "change": function($event) {
        _vm.timeMode = "2"
      }
    }
  }), _vm._v(" "), _vm._m(3)]), _vm._v(" "), _c('span', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.timeMode),
      expression: "timeMode"
    }],
    attrs: {
      "type": "radio",
      "name": "t",
      "value": "3"
    },
    domProps: {
      "checked": _vm._q(_vm.timeMode, "3")
    },
    on: {
      "change": function($event) {
        _vm.timeMode = "3"
      }
    }
  }), _vm._v(" "), _vm._m(4)])])]), _vm._v(" "), (_vm.timeMode == 0) ? _c('div', {
    staticClass: "form-group"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('span', {
    staticClass: "f_left pt5px"
  }, [_vm._v("每")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.hour),
      expression: "hour"
    }],
    staticClass: "form-control ",
    attrs: {
      "type": "text",
      "placeholder": "HH"
    },
    domProps: {
      "value": (_vm.hour)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.hour = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "f_left pt5px"
  }, [_vm._v("小时")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.min),
      expression: "min"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "mm"
    },
    domProps: {
      "value": (_vm.min)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.min = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "f_left pt5px"
  }, [_vm._v("分钟")]), _vm._v(" "), _c('span', {
    staticClass: "dis_block pt5px orange_t  clear"
  }, [_vm._v("不得小于5分钟")])])]) : _vm._e(), _vm._v(" "), (_vm.timeMode == 1) ? _c('div', [_c('div', {
    staticClass: "form-group"
  }, [_vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.durationDays),
      expression: "durationDays"
    }],
    staticClass: "form-control  ",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.durationDays)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.durationDays = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "dis_block pt5px orange_t"
  }, [_vm._v("范围1~7")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.duration1),
      expression: "duration1"
    }],
    staticClass: "form-control ",
    attrs: {
      "type": "text",
      "placeholder": "HH:mm"
    },
    domProps: {
      "value": (_vm.duration1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.duration1 = $event.target.value
      }
    }
  })])])]) : _vm._e(), _vm._v(" "), (_vm.timeMode == 2) ? _c('div', {
    staticClass: "form-group"
  }, [_vm._m(8), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.durationStr),
      expression: "durationStr"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "HH:mm,HH:mm,HH:mm,HH:mm,HH:mm"
    },
    domProps: {
      "value": (_vm.durationStr)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.durationStr = $event.target.value
      }
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.timeMode == 3) ? _c('div', [_c('div', {
    staticClass: "form-group"
  }, [_vm._m(9), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('span', {
    staticClass: "pr15px"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.mon),
      expression: "mon"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.mon) ? _vm._i(_vm.mon, null) > -1 : (_vm.mon)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.mon,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.mon = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.mon = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.mon = $$c
        }
      }
    }
  }), _vm._v(" "), _vm._m(10)]), _vm._v(" "), _c('span', {
    staticClass: "pr15px"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tue),
      expression: "tue"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.tue) ? _vm._i(_vm.tue, null) > -1 : (_vm.tue)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.tue,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.tue = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.tue = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.tue = $$c
        }
      }
    }
  }), _vm._v(" "), _vm._m(11)]), _vm._v(" "), _c('span', {
    staticClass: "pr15px"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.wed),
      expression: "wed"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.wed) ? _vm._i(_vm.wed, null) > -1 : (_vm.wed)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.wed,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.wed = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.wed = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.wed = $$c
        }
      }
    }
  }), _vm._v(" "), _vm._m(12)]), _vm._v(" "), _c('span', {
    staticClass: "pr15px"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.thu),
      expression: "thu"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.thu) ? _vm._i(_vm.thu, null) > -1 : (_vm.thu)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.thu,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.thu = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.thu = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.thu = $$c
        }
      }
    }
  }), _vm._v(" "), _vm._m(13)]), _vm._v(" "), _c('span', {
    staticClass: "pr15px"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fri),
      expression: "fri"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.fri) ? _vm._i(_vm.fri, null) > -1 : (_vm.fri)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.fri,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.fri = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.fri = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.fri = $$c
        }
      }
    }
  }), _vm._v(" "), _vm._m(14)]), _vm._v(" "), _c('span', {
    staticClass: "pr15px"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sat),
      expression: "sat"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.sat) ? _vm._i(_vm.sat, null) > -1 : (_vm.sat)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.sat,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.sat = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.sat = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.sat = $$c
        }
      }
    }
  }), _vm._v(" "), _vm._m(15)]), _vm._v(" "), _c('span', {
    staticClass: "pr15px"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sun),
      expression: "sun"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.sun) ? _vm._i(_vm.sun, null) > -1 : (_vm.sun)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.sun,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.sun = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.sun = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.sun = $$c
        }
      }
    }
  }), _vm._v(" "), _vm._m(16)])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(17), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.duration3),
      expression: "duration3"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "HH:mm"
    },
    domProps: {
      "value": (_vm.duration3)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.duration3 = $event.target.value
      }
    }
  })])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label"
  }, [_vm._v("上报模式")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.upMode),
      expression: "upMode"
    }],
    attrs: {
      "type": "radio",
      "name": "u",
      "value": "0"
    },
    domProps: {
      "checked": _vm._q(_vm.upMode, "0")
    },
    on: {
      "change": function($event) {
        _vm.upMode = "0"
      }
    }
  }), _vm._v(" "), _vm._m(18)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.upMode),
      expression: "upMode"
    }],
    attrs: {
      "type": "radio",
      "name": "u",
      "value": "1"
    },
    domProps: {
      "checked": _vm._q(_vm.upMode, "1")
    },
    on: {
      "change": function($event) {
        _vm.upMode = "1"
      }
    }
  }), _vm._v(" "), _vm._m(19)])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label"
  }, [_vm._v("最大工作时间")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.worktime),
      expression: "worktime"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.worktime)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.worktime = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "dis_block pt5px orange_t"
  }, [_vm._v("单位秒，范围在180~1800")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label"
  }, [_vm._v("报警开关")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.lock),
      expression: "lock"
    }],
    attrs: {
      "type": "radio",
      "name": "l",
      "value": "1"
    },
    domProps: {
      "checked": _vm._q(_vm.lock, "1")
    },
    on: {
      "change": function($event) {
        _vm.lock = "1"
      }
    }
  }), _vm._v(" "), _vm._m(20)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.lock),
      expression: "lock"
    }],
    attrs: {
      "type": "radio",
      "name": "l",
      "value": "0"
    },
    domProps: {
      "checked": _vm._q(_vm.lock, "0")
    },
    on: {
      "change": function($event) {
        _vm.lock = "0"
      }
    }
  }), _vm._v(" "), _vm._m(21)])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('span', {
    staticClass: "red pt5px"
  }, [_vm._v(_vm._s(_vm.alertMsg))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group text-right pr10px"
  }, [_c('button', {
    staticClass: "btn btn-primary modal-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.withdrawBtn
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary modal-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.nextClick
    }
  }, [_vm._v("下一步")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "col-sm-3 control-label"
  }, [_c('span', {
    staticClass: "red pr5px"
  }, [_vm._v("*")]), _vm._v("选择模式")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "control-label"
  }, [_c('div', {
    staticClass: "weight_n"
  }, [_vm._v("间隔模式")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "control-label"
  }, [_c('div', {
    staticClass: "weight_n"
  }, [_vm._v("经典闹钟模式")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "control-label"
  }, [_c('div', {
    staticClass: "weight_n"
  }, [_vm._v("时段闹钟模式")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "control-label"
  }, [_c('div', {
    staticClass: "weight_n"
  }, [_vm._v("星期闹铃模式")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "col-sm-3 control-label"
  }, [_c('span', {
    staticClass: "red pr5px"
  }, [_vm._v("*")]), _vm._v("唤醒间隔")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "col-sm-3 control-label"
  }, [_c('span', {
    staticClass: "red pr5px"
  }, [_vm._v("*")]), _vm._v("间隔天数")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "col-sm-3 control-label"
  }, [_c('span', {
    staticClass: "red pr5px"
  }, [_vm._v("*")]), _vm._v("唤醒时间")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: " col-sm-3 control-label"
  }, [_c('span', {
    staticClass: "red pr5px"
  }, [_vm._v("*")]), _vm._v(" 每天指定唤醒时段（最多5个）")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "col-sm-3 control-label"
  }, [_c('span', {
    staticClass: "red pr5px"
  }, [_vm._v("*")]), _vm._v("星期")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "control-label"
  }, [_c('div', {
    staticClass: "weight_n"
  }, [_vm._v("周一")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "control-label"
  }, [_c('div', {
    staticClass: "weight_n"
  }, [_vm._v("周二")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "control-label"
  }, [_c('div', {
    staticClass: "weight_n"
  }, [_vm._v("周三")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "control-label"
  }, [_c('div', {
    staticClass: "weight_n"
  }, [_vm._v("周四")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "control-label"
  }, [_c('div', {
    staticClass: "weight_n"
  }, [_vm._v("周五")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "control-label"
  }, [_c('div', {
    staticClass: "weight_n"
  }, [_vm._v("周六")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "control-label"
  }, [_c('div', {
    staticClass: "weight_n"
  }, [_vm._v("周日")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "control-label col-sm-3"
  }, [_c('span', {
    staticClass: "red pr5px"
  }, [_vm._v("*")]), _vm._v("唤醒时间")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "control-label"
  }, [_c('div', {
    staticClass: "weight_n"
  }, [_vm._v("正常模式")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "control-label"
  }, [_c('div', {
    staticClass: "weight_n"
  }, [_vm._v("精准模式")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "control-label"
  }, [_c('div', {
    staticClass: "weight_n"
  }, [_vm._v("开")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "control-label"
  }, [_c('div', {
    staticClass: "weight_n"
  }, [_vm._v("关")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6e649125","transformToRequire":{"audio":"src"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/vehiclemonitor/instructions/InsBKAlarmClock.vue
// module id = 1561
// module chunks = 0